import { isFunction } from "@mcwd/typescript-type-guards";
import { type Ref, type MaybeRefOrGetter, isRef, type Reactive, type ShallowReactive } from "vue";

/* A regular value or a reference value */
export type MaybeRef<T> = Ref<T> | T;

/** A reference or a getter */
export type RefOrGetter<T> = Ref<T> | (() => T);

export function isWatchable<T>(value: MaybeRefOrGetter<T>): value is RefOrGetter<T> {
  return isRef(value) || isFunction(value);
}

export type ReactiveOrShallowReactive<T extends Record<PropertyKey, unknown>> = Reactive<T> | ShallowReactive<T>;
export type MaybeReactive<T extends Record<PropertyKey, unknown>> = T | Reactive<T>;
export type MaybeShallowReactive<T extends Record<PropertyKey, unknown>> = T | ShallowReactive<T>;
export type MaybeReactiveOrShallowReactive<T extends Record<PropertyKey, unknown>> = T | Reactive<T> | ShallowReactive<T>;

export type UnwrapReactive<T extends MaybeReactiveOrShallowReactive<Record<PropertyKey, unknown>>> =
  T extends ReactiveOrShallowReactive<infer U extends Record<PropertyKey, unknown>>
    ? U
    :
  T extends infer U extends Record<PropertyKey, unknown>
    ? U
    : never;